import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '@/app/hooks';
import { selectAnyRequestPending } from '@/app/selectors';
import { LOAD_TIMEOUT_MS } from '@/app/api/loadResilience';
import StampSpinner from './StampSpinner';

export default function GlobalLoader() {
  const isPending = useAppSelector(selectAnyRequestPending);
  const [visible, setVisible] = useState(false);
  // DF-0257 — ce voile couvre tout l'écran (`inset-0 z-[9999]`) et n'avait
  // aucune sortie : quand le réseau calait, le seul geste qui en sortait était
  // un rechargement manuel, que personne ne devine. Au-delà du plafond d'une
  // tentative de chargement, on le dit et on propose le geste.
  const [slow, setSlow] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isPending) {
      const id = setTimeout(() => setVisible(true), 200);
      return () => clearTimeout(id);
    }
    setVisible(false);
  }, [isPending]);

  useEffect(() => {
    if (!isPending) {
      setSlow(false);
      return undefined;
    }
    const id = setTimeout(() => setSlow(true), LOAD_TIMEOUT_MS);
    return () => clearTimeout(id);
  }, [isPending]);

  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-cream transition-opacity animate-[loaderFadeIn_180ms_ease-out]">
      <div className="flex flex-col items-center gap-7">
        <StampSpinner size={160} />
        <span
          className="font-display text-ink text-3xl tracking-wide"
          style={{ textShadow: '2px 2px 0 rgba(255, 63, 98, 0.18)' }}
        >
          {t('loading.label')}
        </span>
        {slow && (
          <div className="flex flex-col items-center gap-3">
            <span className="font-mono text-ink text-sm">{t('loading.slowHint')}</span>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="border-2 border-ink bg-ink text-cream font-display text-lg px-6 py-2 shadow-stamp active:translate-y-px"
            >
              {t('loading.retry')}
            </button>
          </div>
        )}
      </div>
      <style>{`
        @keyframes loaderFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
